export const TEXT = {
  ADD_ROUTE: $localize`Add Route`,
  ROUTE: $localize`Route`,
  ADD: $localize`Add`,
};
